// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as OrderScheduleApiModel from "../api-model/OrderScheduleApiModel.bs.js";

function decodeOrderScheduleStatus(order_schedule) {
  return {
          schedule_order_id: order_schedule.schedule_order_id
        };
}

function execute(json) {
  var order_schedule = DeccoUtils$Catalyst.resolveResult(OrderScheduleApiModel.t_decode(json), "OrderScheduleEntityMapper.re");
  return {
          schedule_order_id: order_schedule.schedule_order_id
        };
}

export {
  decodeOrderScheduleStatus ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
